import type { SVGProps } from 'react';
const SvgDesktopAccessDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#desktop_access_disabled_svg__a)">
      <path
        fill="currentColor"
        d="M23 16c0 1.1-.9 2-2 2h-1l-2-2h3V4H6L4 2h17c1.1 0 2 .9 2 2v12Zm-5.5 2-2-2 2 2Zm-2.6 0 6 6 1.3-1.3-4.7-4.7-2-2L1.2 1.8 0 3.1l1 1V16c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h.9ZM3 16V6.1l9.9 9.9H3Z"
      />
    </g>
    <defs>
      <clipPath id="desktop_access_disabled_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDesktopAccessDisabled;
